import { Component, input, signal, OnInit, OnDestroy } from "@angular/core";

import { environment } from "../../../environments/environment";
import { Router } from "@angular/router";
import { BrandImagesService } from "../../../Utils/_services/admin/brand-images/brand-images.service";

interface BubbleImage {
  url: string;
  bubbleIndex: number;
  visible: boolean;
  fading: boolean;
}

@Component({
  selector: "app-left-ui-template",
  imports: [],
  templateUrl: "./left-ui-template.component.html",
  styleUrl: "./left-ui-template.component.css",
})
export class LeftUiTemplateComponent implements OnInit, OnDestroy {
  insizonUrl = environment.insizonFrontendBaseUrl;
  cssClass = input<string | null>(null);
  welcomeText = input<string>("Welcome back");
  welcomeSubtitle = input<string>(
    "We create meaningful connections through technology that brings people closer and transforms the way they experience dating."
  );
  enableBubbleEffect = input<boolean>(true);
  year = signal(new Date().getFullYear());
  totalBubbles = 5;
  bubbleImages = signal<BubbleImage[]>(
    Array.from({ length: 5 }, (_, i) => ({
      url: "",
      bubbleIndex: i,
      visible: false,
      fading: false,
    }))
  );

  private fetchedImages: string[] = [];
  private imageQueue: string[] = [];
  private intervalRef: any;
  private fadeOutTimeout: any;
  readonly DISPLAY_DURATION = 8000;   // image stays visible for 4 seconds
  readonly FADE_DURATION = 2000;  
  private lastBubbleIndex: number = -1;

  constructor(
    private router: Router,
    private brandImagesService: BrandImagesService
  ) {}

  ngOnInit(): void {
    if (this.enableBubbleEffect()) {
      this.fetchImagesAndStart();
    }
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalRef);
    clearTimeout(this.fadeOutTimeout);
  }

fetchImagesAndStart(): void {
  this.brandImagesService.getPublicBrandImages('auth').subscribe({
    next: (res: any) => {
      const dataArray = Array.isArray(res.data) ? res.data : (res.data?.items || []);
      
      if (dataArray.length) {
        // Only get 'Circle' or 'circle' type images
        const validImages = dataArray.filter((img: any) => 
          img.imageType === 'circle' || img.imageType === 'Circle'
        );
        
        if (validImages.length > 0) {
          // Map to URLs
          this.fetchedImages = validImages.map((img: any) => img.imageUrl || img.image?.signedUrl || '');
          this.fetchedImages = this.fetchedImages.filter((url: string) => url !== '');
          
          if (this.fetchedImages.length > 0) {
            this.imageQueue = this.shuffleArray([...this.fetchedImages]);
            this.startBubbleCycle();
          }
        }
      }
    },
    error: (err) => {
      console.error('Error fetching brand images for left ui:', err);
    }
  });
}

startBubbleCycle(): void {
  if (!this.imageQueue.length) return;
  this.showNextImage();
  // interval = display + one fade out (fade in overlaps with next display)
  this.intervalRef = setInterval(() => {
    this.showNextImage();
  }, this.DISPLAY_DURATION + this.FADE_DURATION);
}



pickRandomBubbleIndex(): number {
  let next: number;
  do {
    next = Math.floor(Math.random() * this.totalBubbles);
  } while (next === this.lastBubbleIndex);
  this.lastBubbleIndex = next;
  return next;
}

showNextImage(): void {
  if (!this.imageQueue.length) {
    this.imageQueue = this.shuffleArray([...this.fetchedImages]);
  }

  const nextUrl = this.imageQueue.shift()!;
  const nextBubble = this.pickRandomBubbleIndex();

  // Step 1: fade out current visible bubble
  this.bubbleImages.set(
    this.bubbleImages().map((b) =>
      b.visible ? { ...b, fading: true } : b
    )
  );

  // Step 2: after fade out — clear old, show new
  this.fadeOutTimeout = setTimeout(() => {
    this.bubbleImages.set(
      this.bubbleImages().map((b, i) => {
        if (i === nextBubble) {
          return { ...b, url: nextUrl, visible: true, fading: false };
        }
        // clear url so has-image class is removed on inactive bubbles
        return { ...b, url: '', visible: false, fading: false };
      })
    );
  }, this.FADE_DURATION);
}

  shuffleArray<T>(arr: T[]): T[] {
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }

  goHome() {
    this.router.navigate([""]);
  }
}